import React, { useState } from "react";
import { Modal, TextInput, Button, Group, Stack, Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

// The company comes from the X-Company-Code header the caller sends, so the
// body carries the person being added and nothing else.
const AddAdminModal = ({ opened, onClose, onSave }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSave = async () => {
    // Validation
    if (!firstName.trim()) {
      setError("First name is required");
      return;
    }
    if (!lastName.trim()) {
      setError("Last name is required");
      return;
    }
    if (!email.trim()) {
      setError("Email is required");
      return;
    }
    if (!email.includes("@")) {
      setError("Please enter a valid email address");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const adminData = {
        first_name: firstName.trim(),
        last_name: lastName.trim(),
        email: email.trim(),
      };

      await onSave(adminData);
      handleClose();
    } catch (err) {
      setError(err.message || "Failed to add administrator");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setError("");
    onClose();
  };

  const isFormValid =
    firstName.trim() && lastName.trim() && email.trim() && email.includes("@");

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title="Add New Administrator"
      size="md"
    >
      <Stack gap="md">
        {error && (
          <Alert
            icon={<IconAlertCircle size={16} />}
            color="red"
            variant="light"
          >
            {error}
          </Alert>
        )}

        <TextInput
          label="First Name"
          placeholder="Enter first name"
          value={firstName}
          onChange={e => setFirstName(e.target.value)}
          required
          error={!firstName.trim() && error ? "First name is required" : null}
        />

        <TextInput
          label="Last Name"
          placeholder="Enter last name"
          value={lastName}
          onChange={e => setLastName(e.target.value)}
          required
          error={!lastName.trim() && error ? "Last name is required" : null}
        />

        <TextInput
          label="Email"
          placeholder="Enter email address"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          error={
            (!email.trim() || !email.includes("@")) && error
              ? "Valid email is required"
              : null
          }
        />

        <Group justify="flex-end" gap="sm">
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            loading={loading}
            disabled={!isFormValid}
          >
            Add Administrator
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default AddAdminModal;
